import { ChangeEvent, useEffect, useState, FormEvent } from "react";
import { useNavigate } from "react-router-dom";
import ProductControl from './productControl';


import { NXAlertCircle, NXPlus } from "../../icons";
import "./select-hide.css";
import SelectStyled from "../Select";
import TagSelect from "../TagSelect";
import NestedSelect from "../nestedSelect";
import useApi from "../../api";
import enumChoice, { makeEnumFriendly } from "../../enum";
import VariantSection from "./VariantSection";
import { ImageField } from "../images";
import { toast } from 'react-toastify';
import SEO from "../seo/SEO";
import PageBodyWrapper from "../../components/PageBodyWrapper";


import { NXForm, InputField } from "../../components/common";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

import { fetchRecursiveCategories } from "../../redux/categoriesSlice";
import { fetchProductTypes } from "../../redux/productTypesSlice";
import { fetchCollections } from "../../redux/collectionsSlice";
import { fetchColors } from "../../redux/colorsSlice";
import { fetchTaxClass } from "../../redux/taxClassSlice";
import { fetchProductTags } from "../../redux/productTagsSlice";

import SlateEditor from "../editor/SlateEditor";
import { useFormProtection } from "../unsavedFormProtect";

function AddNewProductMain() {
  const api = useApi();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const categories = useSelector((state: RootState) => state.categories);
  const colors = useSelector((state: RootState) => state.colors);
  const productTypes = useSelector((state: RootState) => state.productTypes);
  const productTags = useSelector((state: RootState) => state.productTags);
  const taxClass = useSelector((state: RootState) => state.taxClass);
  const collections = useSelector((state: RootState) => state.collections);


  
  const [errorData, setErrorData] = useState<any>({});

  const [fromData, setFormData] = useState<any>({
    variants_payload: [{is_default_variant: true}]
  });
  const [productConfig, setProductConfig] = useState<any>({});

  const { isDirty, setIsDirty } = useFormProtection(fromData);


  const handleProductCreate = (event: FormEvent) => {
    event.preventDefault()
    // track_inventory
    const updatedFromData = {
      ...fromData,
      variants_payload: fromData.variants_payload.map((variant: any) => ({
      ...variant,
      track_inventory: productConfig.track_stock
      }))
    };
    api.createProduct(updatedFromData).then((response:any) => {
      toast.success("Product Created Successfully!");
      navigate(`/dashboard/products/edit/${response.id}`); 
    }, (error) => {
      setErrorData(error.response.data);
    })
  };


  const addNewVariant = (event: any) => {
    event.preventDefault();
  
    setFormData((prevFormData: any) => {
      const updatedVariants = [
        ...(prevFormData.variants_payload || []),
        {is_default_variant: false}
      ];
  
      return {
        ...prevFormData,
        variants_payload: updatedVariants,
      };
    });
  };

  const fetchData = () => {
    if (!categories.results.length) {
      dispatch(fetchRecursiveCategories() as any);
    }

    if (!colors.results.length){
      dispatch(fetchColors() as any);
    }

    if (!productTypes.results.length){
      dispatch(fetchProductTypes() as any)
    }

    if (!productTags.results.length){
      dispatch(fetchProductTags() as any);
    }

    if(!taxClass.results.length){
      dispatch(fetchTaxClass() as any);
    }

    if (!collections.results.length){
      dispatch(fetchCollections() as any);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteVariant = async (event: any, id: any, serial: any, is_default_variant:boolean) => {
    event.preventDefault();

    if (is_default_variant) {
      toast.error("Default variant can not be deleted");
      return;
    }

      setFormData((prevFormData: any) => {
        const updatedVariants = [...(prevFormData.variants_payload || [])];
        updatedVariants.splice(serial - 1, 1); // Adjusted for potential off-by-one error
        return {
          ...prevFormData,
          variants_payload: updatedVariants,
        };
      });
      toast.success("Variant deleted successfully");
    
  };


  const onChangeHandler = (event: ChangeEvent<any>) => {
    const { name, value } = event.target;
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const onVariantChange = (data: any, index: number) => {
    console.log(data);
    setFormData((prevFormData: any) => {
      const updatedVariants = [...(prevFormData.variants_payload || [])];
      updatedVariants[index] = data;
  
      return {
        ...prevFormData,
        variants_payload: updatedVariants
      };
    });
  };
  

  const handleSingleChange = (name: any, value: any) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const onProductTypeChange = (name: any, value: any) => {
    setFormData((prevFormData: any) => ({
      ...prevFormData,
      [name]: value
    }));

    setProductConfig(productTypes.results.find((item: any) => item.id === value));
  };

  const markAsDefault = (event: any, id: any, serial: any) => {
    event.preventDefault();
  
    setFormData((prevFormData: any) => {
      const updatedVariants = [...(prevFormData.variants_payload || [])];
      updatedVariants.forEach((variant: any) => {
        variant.is_default_variant = false;
      });
      updatedVariants[serial - 1].is_default_variant = true;
      return {
        ...prevFormData,
        variants_payload: updatedVariants,
      };
    });
  };


  return (
    <PageBodyWrapper bgClass="">
      {/* top action button */}
      <NXForm
        onSubmit={handleProductCreate}
        nonFieldError={errorData}
        >
      <div className="hidden md:flex md:justify-end md:gap-5 md:mb-5 sticky top-0 right-12 z-30 bg-white rounded-md py-4 px-4">
        <button
          onClick={() => navigate('/dashboard/products')}
          className="text-[#0CAF60] border border-[#0CAF60] px-10 py-3 rounded-xl font-nunito font-[900] hover:bg-slate-200">
          Discard
        </button>
        <button
          className="text-white bg-[#0CAF60] hover:bg-[#098d4d] px-10 py-3 rounded-xl font-nunito font-[900] disabled:bg-[#0caf609a]"
          type="submit"
        >
          Save
        </button>
      </div>
      {/* body */}
      <div className="flex flex-col justify-center md:flex-row gap-5 z-20">
        <div className="w-full md:w-[60%]">
          <div className="bg-white p-5 rounded-md">
            <div className="flex items-center gap-3">
              <h1 className="font-nunito font-[900] text-2xl">
                Product Information
              </h1>
              <NXAlertCircle className="text-base-300" />
            </div>
            <div className="my-5">
              <InputField
                type="text"
                id="product_name"
                name="name"
                onChange={onChangeHandler}
                placeholder="Type your product name"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-xl font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                errorData={errorData}
                helpText="The name of the product. This will be displayed on the product page."
                label="Product Name"
                AIConfig={{fieldType: "product_title", fieldValue: fromData.name}}
              />
            </div>
            <div className="my-5">
              <InputField
                type="text"
                id="summary"
                name="summary"
                onChange={onChangeHandler}
                errorData={errorData}
                placeholder="Type product summary"
                className="w-full px-5 py-3 bg-secondary-50 mt-3 rounded-xl font-nunito outline-[#0CAF60] border-[2px] border-dashed"
                helpText="A short description of the product. This will be displayed on the product page."
                label="Product Summary"
                AIConfig={{fieldType: "product_summary", fieldValue: fromData.summary}}
              />
            </div>

            <div className="mt-5">
              <div className="flex flex-col gap-3">
                <label htmlFor="product_description">Description</label>
                <SlateEditor onChange={(value)=>handleSingleChange('description', JSON.stringify(value))}/>
              </div>
            </div>
          </div>

         
         <ImageField isMull={true}  label="Images" name="images" onChange={(name: string, data:any) => handleSingleChange(name, data.map((image: any) => image.id))} />

          {/* tax class */}
          {productConfig.charge_tax && (
          <div className=" bg-white p-5 rounded-md mt-5">
            <div>
              <h1 className="font-nunito font-[900] text-2xl">Tax Class</h1>
            </div>

            <p>Tax Class Dropdown goes there</p>
          </div>)}
          {/* tax class end */}

          {/* tax class */}
          {productConfig.physical_product && (
          <div className=" bg-white p-5 rounded-md mt-5">
            <div>
              <h1 className="font-nunito font-[900] text-2xl">Shipping</h1>
            </div>

            <p>Shipping Handler goes there</p>
          </div>)}
          {/* tax class end */}

          <div className="bg-white p-5 rounded-md mt-5">
          {fromData.variants_payload && fromData.variants_payload.map((variant: any, index: number) => (
              <VariantSection
                key={index}
                productConfig={productConfig}
                onChange={onVariantChange}
                serial={index + 1}
                colors={colors.results}
                deleteVariant={deleteVariant}
                markAsDefault={markAsDefault}
                errorData={errorData}
                name='variants_payload'
                variant={variant}
              />
           ))}

            {productConfig.has_variant && (
                <div className="flex justify-end mt-3">
                <button
                  onClick={addNewVariant}
                  className="flex items-center font-nunito font-[800] gap-2 px-3 py-2 bg-[#0CAF60] text-white rounded-md hover:bg-[#098d4d]"
                >
                  <NXPlus className="mr-1" /> Add Variant
                </button>
                </div>
            )}

          </div>
          <div className="bg-white p-5 rounded-md mt-5">
            <SEO seoData={fromData} onChange={onChangeHandler}/>
          </div>

        </div>


        <div className="w-full md:w-[40%]">
          <div className=" bg-white p-5 rounded-md">
            <div className="w-full mt-3">
              <SelectStyled
                options={enumChoice.publishableStatus}
                name="status"
                onChange={(e) => handleSingleChange('status', e.value)}
                helpText="The status of the product. If the product is not published, it will not be visible to the customers."
                label="Status"
              />
              <div className="absolute inset-y-0 right-0 top-10 flex items-center px-2 pointer-events-none"></div>
            </div>
          </div>

          {/* product organization */}
          <div className=" bg-white p-5 rounded-md mt-5">
            <div className="flex items-center gap-3">
              <h1 className="font-nunito font-[900] text-2xl">
                Product organization
              </h1>
              <NXAlertCircle className="text-base-300" />
            </div>

            <div className="w-full mt-10">
              <div className="pt-3">
                <NestedSelect
                  onChange={(e) => handleSingleChange('category', e.value)}
                  options={categories.results}
                  addComponentName={'category'}
                  label="Category"
                  name='category'
                  helpText="The category to which the product belongs."
                  errorData={errorData}
                />
              </div>
            </div>
            <div className="my-5">
              <div className="pt-3">
                <SelectStyled
                  isMulti={true}
                  options={makeEnumFriendly(collections.results)}
                  onChange={(e) => handleSingleChange('collections', e.value)}
                  errorData={errorData}
                  addComponentName={'collections'}
                  label="Collection"
                  helpText="The collection to which the product belongs."
                />
              </div>
            </div>
            <div className="my-5">
              <div className="pt-3">
                <SelectStyled
                  name='product_type'
                  options={makeEnumFriendly(productTypes.results)}
                  onChange={(e) => onProductTypeChange('product_type', e.value)}
                  errorData={errorData}
                  addComponentName="producttype"
                  label="Product Type"
                  helpText="The type of the product."
                />
              </div>
            </div>
            <div className="my-5">
              <label htmlFor="tags">Tags</label>
              <div className="pt-3">
                <TagSelect
                  errorData={errorData}
                  name='tags_payload'
                  isMulti={true}
                  tagAPI={api.getProductTags}
                  onChange={(e:any) => handleSingleChange('tags_payload', e.map((tag: any) => tag.value))}
                />
              </div>
            </div>
            <div className="my-5">
              <div className="pt-3">
                <SelectStyled
                  errorData={errorData}
                  name='tax_class'
                  options={makeEnumFriendly(taxClass.results)}
                  onChange={(e:any) => handleSingleChange('tax_class', e.value)}
                  label="Tax Class"
                  helpText="The tax class of the product."
                />
              </div>
            </div>
          </div>

          {/* Product Control */}
          <ProductControl productConfig={productConfig} />
          {/* Product Control End */}

        </div>


        <div className="flex flex-col-reverse justify-center gap-5 mb-5 md:hidden">
          <button className="text-[#0CAF60] border border-[#0CAF60] px-10 py-3 rounded-xl font-nunito font-[900]">
            Discard
          </button>
          <button
            className="text-white bg-[#0CAF60] px-10 py-3 rounded-xl font-nunito font-[900] disabled:bg-[#0caf609a]"
            disabled
          >
            Save
          </button>
        </div>
      </div>
      </NXForm>
    </PageBodyWrapper>
  );
}

export default AddNewProductMain;
